import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import i18next, { changeLanguage } from 'i18next';
import { useState } from 'react';

import { supportedLanguage } from '../../utils/supported-language';

// !!! the parent have to set position relative
const LanguageSelector = () => {
    const [selectedLang, setSelectedLang] = useState<string>(i18next.language.split('-')[0] || (window.localStorage.i18nextLng.split('-')[0] as string) || navigator.language.split('-')[0]);

    function onChangeLanguage(lang: string) {
        if (lang) {
            void changeLanguage(lang);
            setSelectedLang(lang);
        }
    }

    return (
        <div>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 'fit-content' }}>
                <Select
                    labelId="language-selector-label"
                    id="language-selector"
                    value={selectedLang}
                    label="Language"
                    autoWidth={true}
                    sx={{
                        color: 'inherit',
                        '.MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(228, 219, 233, 0.25)'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(228, 219, 233, 0.25)'
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(228, 219, 233, 0.25)'
                        },
                        '.MuiSvgIcon-root ': {
                            fill: 'inherit !important'
                        },
                        width: 'max-content',
                        textAlign: 'right'
                    }}
                >
                    {supportedLanguage.map((lang: { value: string; label: string }) => {
                        return (
                            <MenuItem key={`lang_${lang.value}`} onClick={() => onChangeLanguage(lang.value)} value={lang.value}>
                                {lang.label.toUpperCase()}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
};

export default LanguageSelector;
